import { combineReducers } from 'redux'
import R from 'ramda'
import {
  STORE_UNIT_MAP,
  STORE_UNIT_IDS,
  SET_UNIT_FUZZY_FILTER,
  WINDOW_SIZE_CHANGE,
  STORE_ENTITY_API_URL,
  STORE_UNIT_GROUPS,
  SET_UNIT_GROUP_FILTER,
  SET_FILTER_ADJUSTING,
  SET_YEAR,
  SET_SELECTED_UNITS,
  SET_SELECTED_GROUPS,
} from './action-names'

import { sortUnitIds } from './utils'

const unitMap = (state = {}, action) => {
  switch (action.type) {
    case STORE_UNIT_MAP:
      return action.payload
  }
  return state
}

const entityUrl = (state = 'http://192.168.254.226:9021/api', action) => {
  switch (action.type) {
    case STORE_ENTITY_API_URL:
      return action.payload
  }
  return state
}

const unitIds = (state = [], action) => {
  switch (action.type) {
    case STORE_UNIT_IDS: {
      const { unitMap, data } = action.payload
      return R.isEmpty(unitMap) ? data : sortUnitIds(unitMap)(data)
    }
  }
  return state
}

const fuzzyFilter = (state = '', action) => {
  switch (action.type) {
    case SET_UNIT_FUZZY_FILTER:
      return action.payload == null || action.payload === undefined
        ? ''
        : action.payload.trim()
  }
  return state
}

const screenSize = (state = { width: 0, height: 0 }, action) => {
  switch (action.type) {
    case WINDOW_SIZE_CHANGE:
      return action.payload
  }
  return state
}
const allUnitGroups = { text: 'All Unit Groups', value: 'ALL' }

const unitGroups = (
  state = {
    selected: 'ALL',
    groupToUnitMap: {},
    groupList: [allUnitGroups],
  },
  action
) => {
  switch (action.type) {
    case STORE_UNIT_GROUPS: {
      const groupData = action.payload
      const list = R.keys(action.payload).map(val => ({
        text: val,
        value: val,
      }))
      return {
        ...state,
        groupToUnitMap: groupData,
        groupList: [allUnitGroups, ...list],
      }
    }
    case SET_UNIT_GROUP_FILTER:
      return { ...state, selected: action.payload }
  }
  return state
}
const filterAdjusting = (state = false, action) => {
  switch (action.type) {
    case SET_FILTER_ADJUSTING:
      return action.payload
  }
  return state
}

const year = (state = 2016, action) => {
  switch (action.type) {
    case SET_YEAR:
      return action.payload
  }
  return state
}

const groups = (state = {}, action) => {
  switch (action.type) {
    case STORE_UNIT_GROUPS:
      return action.payload
  }
  return state
}

const selectedUnits = (state = [], action) => {
  switch (action.type) {
    case SET_SELECTED_UNITS:
      return action.payload
  }
  return state
}
const selectedGroups = (state = [], action) => {
  switch (action.type) {
    case SET_SELECTED_GROUPS:
      return action.payload
  }
  return state
}

export default combineReducers({
  unitMap,
  unitIds,
  fuzzyFilter,
  screenSize,
  entityUrl,
  unitGroups,
  filterAdjusting,
  year,
  groups,
  selectedUnits,
  selectedGroups,
})
